module.exports = __webpack_public_path__ + "static/media/pdf-icon.70529ce3.svg";